import React from 'react';
import './TargetLanding.css';
import image1 from "../../assets/ButterFly2.png";
import Contact from '../contact/Contact';

const TargetApp = () => {
  return (
    <main className="target-landing section">
      <div className="container">
        <h1 className="section__title">ButterFly Real State Landing Page</h1>

        <p>As part of a comprehensive project to elevate the digital presence of Butterfly Real Estate, I designed a landing page that embodies elegance, functionality, and conversion-focused strategies. Here's how I approached this project to deliver a standout solution that reflects the brand's prestige and vision.</p>

        <div className='target-image-container'>
          <img className="target-image" src={image1} alt="Target App Wireframe" />
        </div>

        <p>The final landing page was designed to not just inform but inspire and convert visitors into leads. By blending creativity with data-driven strategies, I ensured that the page resonates with Butterfly Real Estate’s clientele while achieving measurable business goals.</p>


        <h3>Available Now on Figma Community:</h3>
        <p>
          <a
            href="https://www.figma.com/community/file/1354648708560899189/real-state-website-landing-page"
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: 'underline', color: 'inherit' }}
          >
            ButterFly - Figma Web UI
          </a>
        </p>

        {/* Embedded Figma Prototype – Butterfly Real Estate Website */}
        <div style={{ margin: '30px 0', display: 'flex', justifyContent: 'center' }}>
          <iframe
            src="https://embed.figma.com/design/8KOunQNI5hhVsRbRCaaFcX/Butterfly-real-state-website?node-id=0-1&embed-host=share"
            title="Butterfly Real Estate Website Design"
            width="100%"
            height="450"
            allowFullScreen
            style={{
              maxWidth: '800px',
              border: '1px solid rgba(0, 0, 0, 0.1)',
              borderRadius: '10px'
            }}
          ></iframe>
        </div>


        <section className="target-cta">
          <h3>Hire Me to Elevate Your Brand</h3>
          <p>
            If you’re looking to transform <strong>your website</strong> and create designs that leave a lasting impression, I’m here to deliver exceptional results. Let’s <strong>collaborate</strong> to bring your vision to life!
          </p>
        </section>

        {/* ✅ Contact Form Directly Rendered Below */}
        <div style={{ marginTop: '40px' }}>
          <Contact />
        </div>
      </div>
    </main>
  );
};

export default TargetApp;
